export default "__VITE_ASSET__Mh9b9CiB__"